import React, { useCallback, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Pagination, Status } from '@components'
import EmptyRow from '@components/EmptyRow'
import Flex from '@components/Flex'
import SearchInput from '@components/SearchInput'
import Spinner from '@components/Spinner'
import Table from '@components/Table'
import Td from '@components/Td'
import Tr from '@components/Tr'
import { clientApi } from '@services/ClientApi'
import { formatCpfCnpj } from '@utils/helpers/CpfCnpjFormated'
import { useFilters, useInputBounce, useQuery } from '@utils/hooks'

const styles = {
	searchContainer: 'gap-[8px] mb-[32px] mt-[32px] items-end flex-wrap',
}

function ListSuspiciousDownloads() {
	const query = useQuery()
	const navigate = useNavigate()

	const pageQuery = Number(query.get('page')) || 1
	const searchQs = query.get('search') || ''

	const [search, setSearch] = useState(decodeURIComponent(searchQs))
	const [searchQuery, setSearchQuery] = useState(decodeURIComponent(searchQs))
	const [page, setPage] = useState(pageQuery)

	const { data, isLoading } = clientApi.useListSuspiciousDownloadsQuery({
		page,
		search: encodeURIComponent(searchQuery),
	})

	const searchCallback = useCallback(
		(value: string) => {
			navigate('/clientes/downloads?page=1')
			setSearchQuery(value)
		},
		[navigate]
	)

	useEffect(() => {
		setPage(pageQuery)
	}, [pageQuery])

	useInputBounce(search, searchCallback)

	useFilters({
		search: searchQuery,
		fallbackUrl: '/clientes/downloads',
	})

	return (
		<>
			<Flex className={styles.searchContainer}>
				<SearchInput
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					className='flex-1'
					placeholder='Buscar Cliente'
				/>
			</Flex>

			{isLoading ? (
				<div className='flex justify-center'>
					<Spinner size='md' />
				</div>
			) : (
				<Table
					th={[
						{ label: 'Nome' },
						{ label: 'Email' },
						{ label: 'CPF/CNPJ' },
						{ label: 'Downloads Semana' },
						{ label: 'Max Dia' },
						{ label: 'Status' },
					]}
				>
					{data?.data?.map((item) => (
						<Tr key={item?.id}>
							<Td>
								<Link
									to={`/clientes/downloads/${item.id}`}
									className='text-blue-600 hover:underline'
								>
									{item?.name}
								</Link>
							</Td>
							<Td>{item?.email}</Td>
							<Td>{item?.cpfCnpj ? formatCpfCnpj(item.cpfCnpj) : '-'}</Td>
							<Td>{item?.weekTotal}</Td>
							<Td>{item?.dayMax}</Td>
							<Td>
								<Status status={item?.exceeded ? 'danger' : 'success'}>
									{item?.exceeded ? 'Excedeu' : 'Normal'}
								</Status>
							</Td>
						</Tr>
					))}
					{data?.data?.length === 0 && (
						<EmptyRow
							message='Nenhum download suspeito encontrado'
							tdAmount={6}
						/>
					)}
				</Table>
			)}

			<Pagination
				pageCount={data?.meta.lastPage || 0}
				maxAmount={data?.meta.total || 0}
				perPage={data?.meta.perPage || 0}
			/>
		</>
	)
}

export default ListSuspiciousDownloads
